<template>
    <div>
        <div class="modal fade modal-select" id="modalSelectVoucherType">
            <div class="modal-dialog">
                <div class="modal-content">
                    <!-- Modal body -->
                    <div class="modal-body">
                        <div class="center-modal">
                            <div class="font300 d-flex justify-content-center titl-modal-select">
                                <span class="fs-20">
                                    <span class="font500">{{$t('voucher.general.voucher_type')}}</span>
                                    {{$t('voucher.general.select')}}
                                </span>
                            </div>

                            <!-- Cash screen -->
                            <div class="content-modal-select" v-if="screenType == Constants.CashScreenType">
                                <div
                                    class="center-ttl font300 d-flex justify-content-center"
                                    :class="{'active': voucherType == Constants.VoucherType.receipt_carry_cash.id}"
                                    @click="selectType(Constants.VoucherType.receipt_carry_cash.id)"
                                >
                                    <a href="javascript:void(0);" class="fs-20">{{ Constants.VoucherType.receipt_carry_cash.name }}</a>
                                </div>
                                <div 
                                    class="center-ttl font300 d-flex justify-content-center"
                                    :class="{'active': voucherType == Constants.VoucherType.use_biz_pre_paid_card_cash.id}"
                                    @click="selectType(Constants.VoucherType.use_biz_pre_paid_card_cash.id)"
                                >
                                <a href="javascript:void(0);" class="fs-20">{{ Constants.VoucherType.use_biz_pre_paid_card_cash.name }}</a>
                                </div>
                                <div
                                    class="center-ttl font300 d-flex justify-content-center"
                                    :class="{'active': voucherType == Constants.VoucherType.carry_cash_other.id}"
                                    @click="selectType(Constants.VoucherType.carry_cash_other.id)"
                                >
                                    <a href="javascript:void(0);" class="fs-20">{{ Constants.VoucherType.carry_cash_other.name }}</a>
                                </div>
                            </div>

                            <!-- Local Income Screen -->
                            <div class="content-modal-select" v-if="screenType == Constants.LocalIncomeScreenType">
                                <div
                                    class="center-ttl font300 d-flex justify-content-center"
                                    :class="{'active': voucherType == Constants.VoucherType.receipt_local_placement_income.id}"
                                    @click="selectType(Constants.VoucherType.receipt_local_placement_income.id)"
                                >
                                    <a href="javascript:void(0);" class="fs-20">{{ Constants.VoucherType.receipt_local_placement_income.name }}</a>
                                </div>
                                <div
                                    class="center-ttl font300 d-flex justify-content-center"
                                    :class="{'active': voucherType == Constants.VoucherType.local_placement_income_other.id}"
                                    @click="selectType(Constants.VoucherType.local_placement_income_other.id)"
                                >
                                    <a href="javascript:void(0);" class="fs-20">{{ Constants.VoucherType.local_placement_income_other.name }}</a>
                                </div>
                            </div>

                            <!-- Group voucher type invoice bill -->
                            <div class="content-modal-select" v-if="groupType == Constants.GroupVoucherType.invoice_bill">
                                <div
                                    class="center-ttl font300 d-flex justify-content-center"
                                    :class="{'active': voucherType == Constants.VoucherType.invoice_bill.id}"
                                    @click="selectType(Constants.VoucherType.invoice_bill.id)"
                                >
                                    <a href="javascript:void(0);" class="fs-20">{{ Constants.VoucherType.invoice_bill.name }}</a>
                                </div>
                                <div
                                    class="center-ttl font300 d-flex justify-content-center"
                                    :class="{'active': voucherType == Constants.VoucherType.invoice_invoice.id}"
                                    @click="selectType(Constants.VoucherType.invoice_invoice.id)"
                                >
                                    <a href="javascript:void(0);" class="fs-20">{{ Constants.VoucherType.invoice_invoice.name }}</a>
                                </div>
                                <div
                                    class="center-ttl font300 d-flex justify-content-center"
                                    :class="{'active': voucherType == Constants.VoucherType.invoice_bill_other.id}"
                                    @click="selectType(Constants.VoucherType.invoice_bill_other.id)"
                                >
                                    <a href="javascript:void(0);" class="fs-20">{{ Constants.VoucherType.invoice_bill_other.name }}</a>
                                </div>
                            </div>

                            <!-- Group voucher type contract -->
                            <div class="content-modal-select" v-if="groupType == Constants.GroupVoucherType.contract">
                                <div class="center-ttl font300 d-flex justify-content-center"
                                    :class="{'active': voucherType == Constants.VoucherType.contract_document.id}"
                                    @click="selectType(Constants.VoucherType.contract_document.id)">
                                    <a href="javascript:void(0);" class="fs-20">{{ Constants.VoucherType.contract_document.name }}</a>
                                </div>
                                <div
                                    class="center-ttl font300 d-flex justify-content-center"
                                    :class="{'active': voucherType == Constants.VoucherType.contract_outsourcing.id}"
                                    @click="selectType(Constants.VoucherType.contract_outsourcing.id)"
                                >
                                    <a href="javascript:void(0);" class="fs-20">{{ Constants.VoucherType.contract_outsourcing.name }}</a>
                                </div>
                                <div
                                    class="center-ttl font300 d-flex justify-content-center"
                                    :class="{'active': voucherType == Constants.VoucherType.contract_other.id}"
                                    @click="selectType(Constants.VoucherType.contract_other.id)"
                                >
                                    <a href="javascript:void(0);" class="fs-20">{{ Constants.VoucherType.contract_other.name }}</a>
                                </div>
                            </div>

                            <!-- Group voucher type local expense voucher -->
                            <div
                                class="content-modal-select"
                                v-if="groupType == Constants.GroupVoucherType.local_expense_voucher"
                            >
                                <div
                                    class="center-ttl font300 d-flex justify-content-center"
                                    :class="{'active': voucherType == Constants.VoucherType.local_expense_voucher_carry_cash.id}"
                                    @click="selectType(Constants.VoucherType.local_expense_voucher_carry_cash.id)"
                                >
                                    <a href="javascript:void(0);" class="fs-20">{{ Constants.VoucherType.local_expense_voucher_carry_cash.name }}</a>
                                </div>
                                <div
                                    class="center-ttl font300 d-flex justify-content-center"
                                    :class="{'active': voucherType == Constants.VoucherType.local_expense_voucher_receipt.id}"
                                    @click="selectType(Constants.VoucherType.local_expense_voucher_receipt.id)"
                                >
                                    <a href="javascript:void(0);" class="fs-20">{{ Constants.VoucherType.local_expense_voucher_receipt.name }}</a>
                                </div>
                                <div
                                    v-if="Utils.isEmptyObj(tourInfo) || tourInfo.tour_type == Constants.TourType.international.id"
                                    class="center-ttl font300 d-flex justify-content-center"
                                    :class="{'active': voucherType == Constants.VoucherType.currency_exchange_receipt.id}"
                                    @click="selectType(Constants.VoucherType.currency_exchange_receipt.id)"
                                >
                                    <a href="javascript:void(0);" class="fs-20">{{ Constants.VoucherType.currency_exchange_receipt.name }}</a>
                                </div>
                                <div
                                    v-if="!Utils.isCooperator()"
                                    class="center-ttl font300 d-flex justify-content-center"
                                    :class="{'active': voucherType == Constants.VoucherType.local_expense_voucher_other.id}"
                                    @click="selectType(Constants.VoucherType.local_expense_voucher_other.id)"
                                >
                                    <a href="javascript:void(0);" class="fs-20">{{ Constants.VoucherType.local_expense_voucher_other.name }}</a>
                                </div>
                            </div>

                            <div class="row mt-4 no-gutters g-btn-select">
                                <div class="col-6 pr-2">
                                    <button
                                        :disabled="isDisabledSubmit"
                                        class="btn btn-pink-53 fs-18 w-100"
                                        data-toggle="modal"
                                        @click="addVoucher()"
                                    >{{$t('button.ok')}}</button>
                                </div>

                                <div class="col-6 pl-2">
                                    <button class="btn btn-gray-53 fs-18 w-100" data-dismiss="modal">{{$t('button.cancel')}}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <select-contract-modal></select-contract-modal>
    </div>
</template>

<script>
/* global $ */
import Utils from "@/helpers/utils";
import { Constants } from "@/helpers/constants";
import SelectContractModal from './SelectContractModal.vue';

export default {
    name: "PcSelectVoucherType",
    props: {
        setVoucherType: { type: Function },
        selectFiles: { type: Function },
        screenType: "",
        groupType: "",
        tourInfo: {},
    },
    components: {
        SelectContractModal
    },
    data () {
        return {
            voucherType: 0,
            Utils: Utils,
            Constants: Constants,
            isDisabledSubmit: true,
        };
    },
    beforeMount () {},

    mounted () {
        const el = document.body;
        $("#modalSelectVoucherType").on('show.bs.modal', function () {
            el.classList.add("over-hidden");
        });
        $("#modalSelectVoucherType").on('hide.bs.modal', function () {
            el.classList.remove("over-hidden");
        });
    },

    methods: {
        selectType (type) {
            this.voucherType = type;
            this.setVoucherType(type);
            this.isDisabledSubmit = false;
        },
        viewContracts () {
            $("#modalSelectVoucherType").modal("hide");
            this.$router.push({path: '/voucher/contracts'});
        },
        addVoucher () {
            if (this.voucherType == Constants.VoucherType.contract_document.id) {
                return this.showSelectContractModal();
            }
            this.selectFiles();
            this.isDisabledSubmit = true;
            this.voucherType = 0;
            $("#modalSelectVoucherType").modal("hide");
        },
        showSelectContractModal () {
            $("#modalSelectVoucherType").modal("hide");
            $("#modalSelectContract").modal("show");
        }
    },
};
</script>



// WEBPACK FOOTER //
// src/views/components/pc/Voucher/SelectVoucherTypeModal.vue